import React, { useEffect } from 'react';
import style from './reauthenticateForm.module.scss';
import Input from 'tailwind-components/Input/Input';
import Button from 'tailwind-components/Button/Button';
import PropTypes from 'prop-types';
import useReauthenticate from './useReauthenticate';

function ReauthenticateForm({ setResolver, setUserCredentials }) {
  const {
    error,
    userCredentials,
    loading,
    resolver,
    setPassword,
    reauthenticate
  } = useReauthenticate();

  useEffect(() => {
    if (resolver) setResolver(resolver);
    if (userCredentials) setUserCredentials(userCredentials);
  }, [resolver, userCredentials]);

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        reauthenticate();
      }}
      className={style.genericForm}
    >
      <Input
        name='password'
        label='Current Password'
        type='password'
        error={error}
        placeholder='Enter your current password'
        onChange={e => setPassword(e.target.value)}
        margin='dense'
      />
      <Button
        isLoading={loading}
        disabled={loading}
        text='Reauthenticate'
        variant='primaryLight'
        fill
        type='submit'
      />
    </form>
  );
}

ReauthenticateForm.propTypes = {
  setResolver: PropTypes.func,
  setUserCredentials: PropTypes.func
};

export default ReauthenticateForm;
